import Model from "./Model";

export default class extends Model {
    async loadTable(
      page,
      per_page,
      search = '',
      client_id = null,
      brand_id = null,
      device_type_id = null,
      device_os_id = null,
      version_id = null,
      date = null,
      currentSortColumn = null,
      currentSortOrder = null
    ) {
        let lastPage = 1;
        let response = await axios.get(this.urls.list, {
            params: {
                page,
                per_page,
                search,
                client_id,
                brand_id,
                device_type_id,
                device_os_id,
                version_id,
                date,
                currentSortColumn,
                currentSortOrder
            }
        }).then(response => {

            lastPage = response.data.meta.last_page;

            if(response.data.data !== undefined)
            {
                if(response.data.data.length > 0)
                {
                    return response.data;
                }
            }
            return false;
        });

        let result = {
            tbody: [],
            pages: response.lastPage,
        };

        if(response.data !== undefined && response.data.length > 0)
        {
            response.data.forEach(release => {
                let telem = {
                    tbody: {}
                };
                telem.id = release.id;
                telem.tbody.access_edit = release.access_edit;
                telem.tbody.status = release.status;
                telem.tbody.version_id = release.version_id;
                telem.tbody.version_number = release.device_software_version.full_version;
                telem.tbody.release_scheduled_date = release.scheduled_release_date;
                telem.tbody.release_type = release.device_release_type.name;
                telem.tbody.brand = release.device_software_version.brand.name;
                telem.tbody.client = release.device_software_version.client.name;
                telem.tbody.description = release.description;
                telem.tbody.device_type = release.device_software_version.device_type.name;
                telem.tbody.device_os = release.device_software_version.device_operating_system.name;
                telem.tbody.devices = release.device_deployment_assignments;
                telem.tbody.is_emergency_release = release.is_emergency_release;
                telem.tbody.status_device_assignments = release.status_device_assignments;
                result.tbody.push(telem);
            });
        }
        return result;
    }
}
